import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import { Spinner } from "../ui/spinner";

interface LoadingProps {
  children?: ReactNode;
  isVisible?: boolean;
  small?: boolean;
}

const DEFAULT_LOADING_MESSAGE_KEY = "loading.defaultMessage";

const Loading = ({ children, isVisible = true, small = false }: LoadingProps) => {
  const { t } = useTranslation();

  if (!isVisible) {
    return null;
  }

  const loadingMessage = children ?? t(DEFAULT_LOADING_MESSAGE_KEY);

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      className={cn(
        "flex w-full flex-col items-center justify-center text-center text-muted-foreground",
        small ? "gap-2 p-4" : "gap-3 p-16"
      )}
    >
      <Spinner className={cn("text-primary", small ? "size-6" : "size-10")} />
      <div>{loadingMessage}</div>
    </div>
  );
};

export type { LoadingProps };

export default Loading;
